import { combineReducers } from '../../dependencies';

import { reducer as messages } from '../../modules/messages';
import { reducer as toggle } from '../../modules/toggle';

export default combineReducers({
    messages,
    toggle,
});
